import { StudentDocumentsTab } from '@features/student-documents/components/StudentDocumentsTab'
import { createFileRoute } from '@tanstack/react-router'
import { requireRouteAudience } from '@services/router/routeAccess'

export const Route = createFileRoute('/_layout/students/$studentNo/documents')({
  beforeLoad: requireRouteAudience(['staff']),
  component: RouteComponent,
})

function RouteComponent() {

    const { studentNo } = Route.useParams()

    return <StudentDocumentsTab studentNo={studentNo} />
}
